import React, { useEffect, lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// All CSS is imported here (not in the lazy pages) so the cascade order stays
// exactly as before code-splitting: page styles, then App.css/Responsive.css.
import "./css/Home.css";
import "./css/Aboutus.css";
import "aos/dist/aos.css"; // Import AOS styles
import "./css/Collection.css";
import "./css/Howwedo.css";
import "./css/Fabrics.css";
import "./css/Contact.css";
import './App.css';
import './css/Responsive.css';
import "./css/Login_signup.css";
import Home from "./pages/Home";
import AOS from "aos";

// Landing page ships in the main bundle; every other page loads on demand
const About = lazy(() => import("./pages/About"));
const Collection = lazy(() => import("./pages/Collection"));
const HowWeDoIt = lazy(() => import("./pages/HowWeDoIt"));
const Fabrics = lazy(() => import("./pages/Fabrics"));
const Contact = lazy(() => import("./pages/Contact"));
const Loginsignup = lazy(() => import("./pages/Loginsignup"));

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in ms
      once: true,     // Animation happens only once while scrolling
    });
  }, []);
  return (
    <Router>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/collection" element={<Collection />} />
          <Route path="/how-we-do-it" element={<HowWeDoIt />} />
          <Route path="/fabrics" element={<Fabrics />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login_signup" element={<Loginsignup />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default App;
